import { render } from "./RegionSummaryTable.vue?vue&type=template&id=cf71e2ae&scoped=true"
import script from "./RegionSummaryTable.vue?vue&type=script&lang=js"
export * from "./RegionSummaryTable.vue?vue&type=script&lang=js"

import "./RegionSummaryTable.vue?vue&type=style&index=0&id=cf71e2ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf71e2ae"]])

export default __exports__